import * as extendUtils from '../../../utils/object/extend.utils';
import {cbssportsStagingConfig} from '../cbssports';
import {PrismConfigOptions} from '../environment-variables.interface';
import {sportslineStagingConfig} from './staging.config';

export const sportslineProductionConfig: PrismConfigOptions = extendUtils.deepExtend({}, [sportslineStagingConfig, {
  environmentName: "Sportsline Production Environment",
  ionicEnvName: 'prod',
  hubApi: 'https://cms.sportsline.com',
}]);



// WEBPACK FOOTER //
// ./src/app/environment-variables/sportsline/prod.config.ts